import type { DashboardResponse } from "@hz/common/api-types/dashboard";
import type {
  ListMerchantAccountsResponse,
  ProductReportRow } from "@hz/common/google/types";
import {
  AccountIssue,
  AccountIssuesResponse,
  AggregateProductStatus,
  AggregateProductStatusResponse
} from "@hz/common/google/types";

import { api } from "@state/apiSlice";
import { Tags } from "@state/apiSlice/tags";

const gmcRequestsSlice = api.injectEndpoints({
  endpoints: (build) => ({
    merchantAccountsList: build.query<ListMerchantAccountsResponse, {}>({
      query: () => ({
        url: "/gmc/accounts",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),
    getDashboard: build.query<DashboardResponse, {}>({
      query: () => ({
        url: "/gmc/account/dashboard",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    getReport: build.query<ProductReportRow[], void>({
      query: () => ({
        url: "/gmc/product/issues",
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    // disconnectGoole: build.mutation<DisconnectGoogleResponse, void>({
    //   query: () => ({
    //     url: "/oauth/google/disconnect",
    //     method: "POST",
    //     headers: {
    //       "Content-Type": "application/json",
    //     },
    //     body: {},
    //   }),
    //   invalidatesTags: [{ type: Tags.ConnectionStatus }],
    // }),
  }),
});

export default gmcRequestsSlice;
